import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getLedgerWallets } from 'services/LedgerService'
import { LedgerWalletsRequestParams } from 'types/ledger/ledgerWalletTransactions'
import { API_PAGINATION_LIMIT, API_PAGINATION_OFFSET } from 'utils/pagination'

export const useGetLedgerWallets = ({
  currencyCode,
  searchTerm,
  enabled = true,
  size = API_PAGINATION_LIMIT,
  page = API_PAGINATION_OFFSET,
  start,
  end,
  includeCustomerWallets,
}: LedgerWalletsRequestParams & { enabled?: boolean }) => {
  return useQuery({
    enabled,
    queryKey: reactQueryKeys.ledgerWallets({
      currencyCode,
      searchTerm,
      size,
      page,
      start,
      end,
      includeCustomerWallets,
    }),
    queryFn: () =>
      getLedgerWallets({
        currencyCode,
        searchTerm,
        size,
        page,
        start,
        end,
        includeCustomerWallets,
      }),
  })
}
